const SEARCHBLOX_SPECIAL_CHARS_REGEX = new RegExp(
  `\\s*[${RegExp.escape('+-&|!(){}[]^"~*?:\\')}]\\s*`,
  'gi'
);

/**
 * Replaces special characters (and any spaces on either side) with a single space.
 * - "hello-world" -> "hello world"
 * - "hello: world" -> "hello world"
 * - "hello world!" -> "hello world "
 */
export const clean = (query: string | undefined) => {
  return query?.replace(SEARCHBLOX_SPECIAL_CHARS_REGEX, ' ');
};

/**
 * Creates a fuzzy search on each word in a query.
 * - "hello world" => "hello~ world~"
 * - "hello world!" => "hello~ world~"
 * - "hello-world" => "hello-world~"
 */
export const fuzz = (query: string | undefined) => {
  return query
    ?.match(/\b\S+\b/g)
    ?.map((word) => `${word}~`)
    .join(' ');
};
